"use client";
import React, { memo, useMemo, type FC } from "react";
import multiavatar from "@multiavatar/multiavatar";
import clsx from "clsx";

interface WalletAddressAvatarProps {
  walletAddress: string;
  height?: number;
  width?: number;
  isBordered?: boolean;
}

const WalletAddressAvatar: FC<WalletAddressAvatarProps> = ({
  width,
  height,
  walletAddress,
  isBordered = false,
}) => {
  const svgCode = useMemo(() => {
    return multiavatar(walletAddress?.toLowerCase());
  }, [walletAddress]);

  return (
    <div className="w-full h-full flex">
      <div
        className={clsx(
          "rounded-full overflow-hidden",
          isBordered ? "border border-primary" : ""
        )}
        style={{ width, height }}
        dangerouslySetInnerHTML={{ __html: svgCode }}
      />
    </div>
  );
};

export default memo(WalletAddressAvatar);
